import React from 'react';
import { useIntl } from 'react-intl';
import { CrownIcon } from '@/components/_shared/Icons';
import styles from './TopOrganizerLabel.module.scss';

interface TopOrganizerLabelProps {
  showCrownIcon?: boolean;
}

export const TopOrganizerLabel: React.FC<TopOrganizerLabelProps> = ({ showCrownIcon = false }) => {
  const { formatMessage } = useIntl();
  return (
    <span className={styles.label}>
      {showCrownIcon && (
        <span className={styles.crownIcon}>
          <CrownIcon />
        </span>
      )}
      {formatMessage({ id: 'Top Organizer', defaultMessage: 'Top Organizer' })}
    </span>
  );
};
